export default __webpack_public_path__ + "static/media/bg.a02587b5.jpg";